export enum HourSlot {
  From8to10 = '8h - 10h',
  From10to12 = '10h - 12h',
  From14to16 = '14h - 16h',
  From16to18 = '16h - 18h'
}
